<template>
    <div id="wind">
        <iframe id="windIframe" :src="url" frameborder="0"></iframe>
    </div>
</template>

<script>
    import url from "../utils/UrlApi"

    export default {
        name: "Wind",
        data() {
            return {
                url: ''
            };
        },
        computed: {
            gpsState: {
                get() {
                    return this.$store.state.gpsState;
                },
            },
            // url:{
            //     get(){
            //         return  url.windy+"?city="+this.gpsState.city
            //     }
            // }
        },
        created() {
            this.getUrl()
        },
        methods: {
            getUrl() {
                this.url = url.windy + "?city=" + this.gpsState.city + '&timer=' + new Date().getTime()
            }
        }
    }

</script>
<style lang="less" scoped>
    #wind {
        margin: 0;
        padding: 0;
        flex: 1;
        /*height: calc(100vh - 95px);*/
        #windIframe {
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
        }
        // width: 100%;
        // margin: 0 auto;
        // min-height: calc(100vh - 145px);
        // height: auto;
        // padding: 30px;
        // .content {
        //     min-height: 100%;
        //     background-color: #ffffff;
        // }
    }
</style>